<app-header></app-header>

<ion-content [fullscreen]="true" class="consent-content">
  <div class="consent-container">
    <div class="consent-card">
      <div class="consent-header">
        <h1 class="consent-title">{{ "CONSENT.TITLE" | translate }}</h1>
        <p class="consent-subtitle">{{ "CONSENT.SUBTITLE" | translate }}</p>
      </div>

      <div class="consent-body">
        <p class="consent-description">{{ "CONSENT.DESCRIPTION" | translate }}</p>

        <div class="consent-options">
          <div class="consent-option consent-active">
            <div class="option-header">
              <h3>{{ "CONSENT.NECESSARY.TITLE" | translate }}</h3>
              <ion-badge color="primary">{{ "CONSENT.ALWAYS_ACTIVE" | translate }}</ion-badge>
            </div>
            <p>{{ "CONSENT.NECESSARY.DESCRIPTION" | translate }}</p>
          </div>

          <div class="consent-option" [class.consent-active]="consentSettings().analytics">
            <div class="option-header">
              <h3>{{ "CONSENT.ANALYTICS.TITLE" | translate }}</h3>
            </div>
            <p>{{ "CONSENT.ANALYTICS.DESCRIPTION" | translate }}</p>
          </div>
        </div>

        <div class="consent-actions">
          <ion-button expand="block" (click)="acceptAll()" [disabled]="isLoading()">
            {{ "CONSENT.ACCEPT_ALL" | translate }}
          </ion-button>

          <ion-button expand="block" fill="outline" (click)="acceptNecessary()" [disabled]="isLoading()">
            {{ "CONSENT.ACCEPT_NECESSARY" | translate }}
          </ion-button>
        </div>

        <div class="consent-footer">
          <p class="consent-note">{{ "CONSENT.NOTE" | translate }}</p>
          <p class="consent-legal">{{ "CONSENT.LEGAL" | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</ion-content>
